import * as apiClient from "./axiosApiClient";
import { joinUrlWithRoute } from "../utils/urlUtils";

const baseUrl = apiClient.REACT_APP_USER_API_BASE_URL;

export function createUser(request) {
    return apiClient.post(baseUrl, request);
}

export function deleteUser(request) {
    const url = joinUrlWithRoute(baseUrl, `/${request}`);
    return apiClient.httpDelete(url);
}

export function getUser(userId) {
    const url = joinUrlWithRoute(baseUrl, `/${userId}`);
    return apiClient.get(url);
}

export function updateUser(userId, request) {
    const url = joinUrlWithRoute(baseUrl, `/${userId}`);
    return apiClient.put(url, request);
}

export function getUserActivationLink(userId) {
    const url = joinUrlWithRoute(baseUrl, `/${userId}/activation-link`);
    return apiClient.get(url);
}

export function getAvaliableAccounts() {
    const url = joinUrlWithRoute(baseUrl, "/avaliable-accounts");
    return apiClient.get(url);
}

export function switchAccount(request) {
    const url = joinUrlWithRoute(baseUrl, "/switch-account");
    return apiClient.post(url, request);
}

export function resetPassword(request) {
    const url = joinUrlWithRoute(baseUrl, "/reset-password");
    return apiClient.post(url, request);
}

export function verifyResetCode(request) {
    const url = joinUrlWithRoute(baseUrl, "/verify-reset-code");
    return apiClient.post(url, request);
}

export function forgotPassword(request) {
    const url = joinUrlWithRoute(baseUrl, "/forgot-password");
    return apiClient.post(url, request);
}

export function inviteUsers(request) {
    const url = joinUrlWithRoute(baseUrl, "/invite-users");
    return apiClient.post(url, request);
}

export function dumpAccountCache() {
    const url = joinUrlWithRoute(baseUrl, "/dump-cache");
    return apiClient.post(url, {});
}
